import { IDataUploadService } from './data_upload_service'
import { ILookUpService } from '../settings/lookup_service'
import { MessageBox, Toast } from '../helpers/message_box';
import { AppServices, AngularServices, LookUpStores } from '../helpers/config_keys';
import { IContactService } from '../address/contact_service';
let _: UnderscoreStatic = require("underscore")
interface IModel {
    name: string
    fields: IModelField[]
}

interface IModelField {
    name: string
    property: string
    required: boolean
    type: FieldType
    lookup?: string
}

enum FieldType {
    Text,
    Number,
    Select
}

class DataUploadCtrl {
    errorCount: number;
    saving: boolean;
    data: any[];
    model: IModel;

    lookUps = [LookUpStores.Groups]

    static $inject = [AngularServices.Scope, "XLSXReaderService", AngularServices.UibModalInstance,
    AppServices.ContactService, AppServices.LookUpService, "SelectModel"];

    constructor(private $scope: any,
        private XLSXReaderService: any,
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private contactService: IContactService,
        private lookUpService: ILookUpService,
        private selectModel: string) {
        this.loadLookUps()

        if (selectModel) { this.model = _.findWhere(this.models, { name: selectModel }) }

        $scope.$watch(() => this.data, (n: any, o: any) => {
            this.errorChecker()
        }, true)

        this.$scope.fileChanged = (ele: any) => {
            this.readFileData(ele)
        }
    }

    remove(index: number) { this.data.splice(index, 1) }

    clearFile() {
        $("#uploadDoc").val(null)
        this.data = null
    }

    checkEntry(item: any) {
        var check = { error: false, message: "" };

        this.model.fields.forEach(field => {
            if (field.required && !item[field.property]) {
                check.error = true;
                check.message += `${field.name} is required. `;
            }
        });

        return check;
    };


    uploadData() {
        this.saving = true
        let theData = angular.copy(this.data)
        switch (this.model.name) {
            case "Contact":
                this.contactService.upload(theData).then((res) => { this.afterUpload(res.success) })
                break;
            default:
                break;
        }
    }

    close() { this.$uibModalInstance.dismiss("cancel") }

    private afterUpload(success: boolean) {
        this.saving = false
        if (success) { this.$uibModalInstance.close('SAVED') }
    }

    private readFileData(files: any) {
        let excelFile = files[0];
        this.XLSXReaderService.readFile(excelFile, true, true).then((xlsxData: any) => {
            let data: Array<any> = xlsxData.sheets["Sheet1"];
            this.data = data.map((rec: any) => { return this.refactorRecord(rec) })
        });
    };

    private refactorRecord(data: any) {
        let self: any = this
        let rec: any = {};
        this.model.fields.forEach((field) => {
            switch (field.type) {
                case FieldType.Text:
                    rec[field.property] = data[field.name]
                    break;
                case FieldType.Number:
                    rec[field.property] = +data[field.name]
                    break;
                case FieldType.Select:
                    rec[field.property] = this.getLookUpId(self[field.lookup], data[field.name])
                    break;
                default:
                    break;
            }
        })

        rec._entry = this.checkEntry(rec)
        return rec;
    }

    private errorChecker() {
        this.errorCount = 0;
        if (this.data) {
            this.data = this.data.map((item) => {
                item._entry = this.checkEntry(item)
                if (item._entry.error) {
                    this.errorCount++
                }
                return item;
            })
        }
    }

    private getLookUpId(data: Array<any>, name: string) {
        let item = _.findWhere(data, { name });
        return (item) ? item.id : 0
    }

    private getLookUpName(data: Array<any>, id: number) {
        let item = _.findWhere(data, { id });
        return (item) ? item.name : ""
    }

    private loadLookUps() {
        let self: any = this;
        this.lookUps.forEach((lookup) => {
            this.lookUpService.fetch(lookup).then((res) => {
                if (res.success) { self[lookup] = res.data }
            })
        })
    }

    models: IModel[] = [
        {
            name: "Contact",
            fields: [
                { name: "Name", property: "name", required: true, type: FieldType.Text },
                { name: "PhoneNumber", property: "phoneNumber", required: true, type: FieldType.Text },
                { name: "Email", property: "email", required: false, type: FieldType.Text },
                { name: "Group", property: "groupId", required: true, type: FieldType.Select, lookup: LookUpStores.Groups }
            ]
        }
    ]
}

export { DataUploadCtrl }


// WEBPACK FOOTER //
// ./app/data_upload/data_upload_ctrl.ts